<mat-tab-group
  onsip-mat-tab-table
  (selectedIndexChange)="onSelectedIndexChange($event)"
  mat-stretch-tabs="false"
>
  <mat-tab label="Basic Queue Settings">
    <ng-template matTabContent>
      <onsip-acd-queues-basic-tab [queue]="queue" (mode)="mode = $event">
      </onsip-acd-queues-basic-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Agent Settings">
    <ng-template matTabContent>
      <onsip-acd-queues-agent-tab [queue]="queue" (mode)="mode = $event">
      </onsip-acd-queues-agent-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Caller Settings">
    <ng-template matTabContent>
      <onsip-acd-queues-caller-tab [queue]="queue" (mode)="mode = $event">
      </onsip-acd-queues-caller-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Enhanced Queue">
    <ng-template matTabContent>
      <onsip-acd-queues-enhanced-tab
        [userUnlimited]="userUnlimited"
        [queue]="queue"
        (mode)="mode = $event"
      >
      </onsip-acd-queues-enhanced-tab>
    </ng-template>
  </mat-tab>
</mat-tab-group>
